import { render, staticRenderFns } from "./DeleteCustomer.vue?vue&type=template&id=5a781078&scoped=true&"
import script from "./DeleteCustomer.vue?vue&type=script&lang=js&"
export * from "./DeleteCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCustomer.vue?vue&type=style&index=0&id=5a781078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a781078",
  null
  
)

export default component.exports